import { lazy, Suspense } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { CircularProgress, Box } from "@mui/material";
import Login from "./Login";
import { ProtectedRoute } from "./ProtectedRoute";

// Lazy load all pages - only loaded when navigated to
const Home = lazy(() => import("./Home"));
const Audit = lazy(() => import("./Audit"));
const Occurrences = lazy(() => import("./Occurrences"));
const InventoryDetail = lazy(() => import("./InventoryDetail"));

const PageLoader = () => (
  <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100vh" }}>
    <CircularProgress />
  </Box>
);

const App = () => {
  return (
    <BrowserRouter>
      <Suspense fallback={<PageLoader />}>
        <Routes>
          <Route
            path="/"
            element={
              <ProtectedRoute>
                <Home />
              </ProtectedRoute>
            }
          />
          <Route
            path="/audit"
            element={
              <ProtectedRoute>
                <Audit />
              </ProtectedRoute>
            }
          />
          <Route
            path="/occurrences"
            element={
              <ProtectedRoute>
                <Occurrences />
              </ProtectedRoute>
            }
          />
          <Route
            path="/aires-emission"
            element={
              <ProtectedRoute>
                <InventoryDetail />
              </ProtectedRoute>
            }
          />
          <Route path="/login" element={<Login />} />
        </Routes>
      </Suspense>
    </BrowserRouter>
  );
};

export default App;
